export default __webpack_public_path__ + "images/cert-e60.png?26e46501ca739ddb663f62ab61ecdb85";